export default __webpack_public_path__ + "static/34-2a5b771756458d57b187988e913d62c1.png";